import useUser from "@saleor/hooks/useUser";
import { sectionNames } from "@saleor/intl";
import { SmopUserTypeCode } from "@saleor/types/globalTypes";
import { asSortParams } from "@saleor/utils/sort";
import { parseQueryString } from "@saleor/utils/urls";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation, useParams } from "react-router-dom";

import { WindowTitle } from "../components/WindowTitle";
import MasterFulfillmentComponent from "../masterFulfillment/views/MasterFulfillment";
import {
  masterFulfillmentListPath,
  masterFulfillmentListUrl,
  masterFulfillmentPath,
  masterFulfillmentUrl,
  orderListUrl,
  OrderListUrlQueryParams,
  OrderListUrlSortField,
  orderUrl,
  OrderUrlQueryParams
} from "./urls";
import OrderDetailsComponent from "./views/OrderDetails";
import OrderListComponent from "./views/OrderList";

const OrderList: React.FC = () => {
  const location = useLocation();
  const user = useUser();
  const isOpsAdmin = user.user?.userType.code === SmopUserTypeCode.OMI_OPS;
  const qs = parseQs(location.search.substring(1));
  const params = asSortParams(
    qs,
    OrderListUrlSortField,
    OrderListUrlSortField.date,
    !isOpsAdmin
  ) as OrderListUrlQueryParams;

  return <OrderListComponent params={params} />;
};

const OrderDetails: React.FC = () => {
  const location = useLocation();
  const { id } = useParams();
  const params = parseQueryString<OrderUrlQueryParams>(
    location.search.substring(1)
  );

  return (
    <OrderDetailsComponent
      id={decodeURIComponent(id)}
      params={params}
      backUrlRedirect={orderListUrl()}
      detailsUrl={orderUrl}
    />
  );
};

const MasterFulfillmentList: React.FC = () => {
  const location = useLocation();
  const qs = parseQs(location.search.substring(1));
  const params = asSortParams(
    qs,
    OrderListUrlSortField,
    OrderListUrlSortField.date,
    false
  ) as OrderListUrlQueryParams;

  return <MasterFulfillmentComponent params={params} />;
};

const MasterFulfillmentDetails: React.FC = () => {
  const location = useLocation();
  const { id } = useParams();
  const params = parseQueryString<OrderUrlQueryParams>(
    location.search.substring(1)
  );

  return (
    <OrderDetailsComponent
      id={decodeURIComponent(id)}
      params={params}
      backUrlRedirect={masterFulfillmentListUrl()}
      detailsUrl={masterFulfillmentUrl}
    />
  );
};

const Component = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.fulfillment)} />
      <Routes>
        <Route path={""} element={<OrderList />} />
        <Route path={":id"} element={<OrderDetails />} />
        <Route
          path={masterFulfillmentListPath}
          element={<MasterFulfillmentList />}
        />
        <Route
          path={masterFulfillmentPath(":id")}
          element={<MasterFulfillmentDetails />}
        />
      </Routes>
    </>
  );
};

export default Component;
